import {Moment} from 'moment';

const SELECTOR_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
};

type DatePickerSelectorProps = {
  position: string
}

type SingleDatePickerProps = {
    date: Moment | undefined,
    dateFormat: string,
    placeholder: string | undefined,
    elementId: string,
    onChange: (date: Moment) => void,
    onFocus?: (focused: boolean) => void,
    minDate?: Moment | null | undefined,
    maxDate?: Moment | null | undefined,
    position?: string | undefined,
}

type DatePickerControlsProps = {
    elementId: string,
    placeholder: string,
    onStartChange: () => void,
    onChange: (date: string) => void,
    onEndChange: (date: string) => void,
    value: Moment | null | undefined,
    dateFormat: string,
    regMask?: RegExp,
}

export {
  SingleDatePickerProps,
  DatePickerControlsProps,
  DatePickerSelectorProps,
  SELECTOR_POSITION,
};
